/* eslint-disable-file */
import $ from 'jquery';
import { getStudentImage } from '../../utils.js';
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Bag from '../../../../blocks/scripts/reusable/icons/Bag';
import Close from '../../../../blocks/scripts/reusable/icons/Close';
import Medal from '../../../../blocks/scripts/reusable/icons/Medal';
import StarModal from '../../../../blocks/scripts/reusable/icons/StarModal';

export default ({ bolsista = {}, initialOpen = false, openModalButton }) => {
	const [ showModal, setShowModal ] = useState(initialOpen);

	const handleClose = () => setShowModal(false);

	useEffect(() => {
		if (openModalButton) {
			$(openModalButton).on('click', () => {
				setShowModal(true);
			});
		}
	}, []);

	return (
		<>
			<Modal show={showModal} onHide={handleClose}>
				<div className="modal-container">
					<Modal.Header>
						<picture>
							<img src={getStudentImage(bolsista)} alt="Imagem" />
						</picture>
						<div className="modal-data-header">
							<div className="modal-text">
								<Modal.Title>
									<Bag size="30px" color="#3FA9F5" secondaryColor="#FF811F" />
									<span className="modal-title-text">{bolsista.title.rendered}</span>
								</Modal.Title>

								{!bolsista.scholarship_born_date ? '' :
									<div className="modal-age">
										{getAge(bolsista.scholarship_born_date)} anos
									</div>
								}

								<button type="button" onClick={handleClose} className="modal-btn-close" aria-label="Close">
									<Close size="25px" color="#FF811F" />
								</button>

							</div>
							<div className="modal-description-name">
								<div className="modal-description" dangerouslySetInnerHTML={{ __html: bolsista.scholarship_description }}>
								</div>
							</div>
						</div>
					</Modal.Header>
					<Modal.Body>
						<ul>
							{bolsista.student_class.name &&
								<li>
                                    <StarModal size="20px" color="#3FA9F5" />
                                    {bolsista.student_class.name}
                                </li>
                            }

							<li>
                                <StarModal size="20px" color="#3FA9F5" />
                                Egresso(a) na {bolsista.scholarship_school}
                            </li>
							<li>
                                <StarModal size="20px" color="#3FA9F5" />
								Natural de {bolsista.scholarship_city} -{" "}
								{bolsista.scholarship_state}
							</li>

							{Array.isArray(bolsista.scholarship_goals_details)
							&& bolsista.scholarship_goals_details.map(item => 
								<li>
									<Medal size="25px" color="#FFFF00" />
									{item.award.name} ({item.award.year})
								</li>
							)}

							{bolsista.scholarship_contest_details.map((concurso, i) => (
								concurso.scholarship_contest &&
									<li key={i}>
                                        <Medal size="25px" color="#FFFF00" />
                                        {concurso.scholarship_contest}
                                    </li>
							))}
						</ul>
					</Modal.Body>
				</div>
			</Modal>
		</>
	);
};

function getAge(dateString) {
	let dataAtual = new Date();
	let anoAtual = dataAtual.getFullYear();
	let anoNascParts = dateString.split("-");
	let diaNasc = anoNascParts[0];
	let mesNasc = anoNascParts[1];
	let anoNasc = anoNascParts[2];
	let idade = anoAtual - anoNasc;
	let mesAtual = dataAtual.getMonth() + 1;

	//Se mes atual for menor que o nascimento, nao fez aniversario ainda;
	if (mesAtual < mesNasc) {
		idade--;
	} else {
		//Se estiver no mes do nascimento, verificar o dia
		if (mesAtual == mesNasc) {
			if (new Date().getDate() < diaNasc) {
				//Se a data atual for menor que o dia de nascimento ele ainda nao fez aniversario
				idade--;
			}
		}
	}
	return idade;
}
